
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
@Component({
    selector: 'app-svg-icon',
        standalone: true,
imports: [],
    templateUrl: './svg-icon.component.html',
    styleUrl: './svg-icon.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SvgIconComponent {
  @Input() name: string = '';
}
